<div class="menu-items">
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/subscriptions/youtube-sub' || url === '/portal/subscriptions'}" (click)="selectMenu('youtube-sub')">
        YouTube<span></span>
    </div>    
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/subscriptions/authentisign'}" (click)="selectMenu('authentisign')">
        Authentisign<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/subscriptions/toolkitcma'}" (click)="selectMenu('toolkitcma')">
        ToolkitCMA<span></span>
    </div>
    <div *ngIf="!isLOBUser" class="menu-item" [ngClass]="{'selected-menu':url === '/portal/subscriptions/docusign'}" (click)="selectMenu('docusign')">
        DocuSign<span></span>
    </div>
</div>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="selectMenuConfirmation()"
  #changeMenuModal
>
</app-search-update-confirmation>